export const TournamentOverviewList = `query getTournamentOverviewList($facilityId: ID!, $take: Int, $skip: Int, $list: TournamentListKinds) {
  node(id: $facilityId) {
    ... on Facility {
      tournaments {
        list(
          take: $take
          skip: $skip
          list: $list
        ) {
          totalCount
          items {
            ...TournamentOverviewItem
          }
        }
      }
    }
  }
}
    
fragment TournamentOverviewItem on Tournament {
  ...CourseTournamentForOverview
}

fragment CourseTournamentForOverview on CourseTournament {
  teamSettings {
    size
  }
  startDate
  endDate
  id
  logo
  name
  rounds {
    id
    course {
      image {
        url
      }
    }
  }
  invitation {
    id
    invitationEmail
  }
  availability
  sponsors {
    logoUri
    name
  }
  participants {
    allInvitationsCount
    declinedCount
    withdrawnCount
  }
  keyValues {
    key
    value
  }
  versionInfo {
    state
  }
  signUpStartTime
  signUpEndTime
  locationsConfiguration {
    paymentUrl
    remainingSpots
    fee
    displayFee
  } 
}`;

export const TournamentOverview = `query getTournament($tournamentId: ID!) {
  node(id: $tournamentId) {
    ...on CourseTournament {
  numberOfRounds
  unit
  anyRoundHasNonDefaultMaxScoringMethod
  signUpStartTime
  signUpEndTime
  locationsConfiguration {
    paymentUrl
    remainingSpots
    fee
    displayFee
  }
  keyValues {
    key
    value
  }
  settings {
    gameType
    allowPlayAhead
    allowMulligans
    attempts
    hcpKind
    gameFormat
    ignoreBottomRounds
  }
  sponsors {
    logoUri
    name
  }
  participants {
    allInvitationsCount
    declinedCount
    withdrawnCount
  }
  teamSettings {
    size
  }
      logo
      name
      id
      startDate
      endDate
      description
      leaderboard {
        records {
          items {
            playername
            playerId
            id
            email
          }
        }
      }
      rounds {
        id
        embeddedGame {
          closestToPin {
            holes
          }
          longestDrive {
            holes
          }
        }
        course {
          description
          displayName
          image {
            url
          }
        }
      }
    }
  }
}`;

export const TournamentRoundDetails = `query getTournamentRoundDetails($tournamentId: ID!, $roundId: ID!) {
  node(id: $tournamentId){
    ... on CourseTournament{
      rounds {
        course {
          displayName
          description
          image {
            url
          }
          numbersOfHoles  
        }
        settings {
          maleTee {
            name
            courseDistance
            par
          }
          femaleTee {
            name
            courseDistance
            par
          }
          gameSettings {
            puttingMode
            windSpeed
            fairwayFirmness
            greenFirmness
            greenStimp
            pinDifficulty
          }
        }
        embeddedGame {
          longestDrive {
            holes
          }
        }
      }
      round(roundId: $roundId){
        settings {
          femaleTee {
            name
            par
            courseDistance
          }
          maleTee {
            name
            par
            courseDistance
          }
          gameSettings {
            fairwayFirmness
            greenFirmness
            greenStimp
            puttingMode
            windSpeed
            pinDifficulty
          }
        }
        course {
          numbersOfHoles
          tees {
            courseDistance
            name
            par
          }
          description
          displayName
          image {
            url
          }
        }
      }
    }
  }
}`;

export const TournamentNationalities = `query TournamentLeaderboard(
  $tournamentId: ID!
) {
  node(id: $tournamentId) {
    ... on CourseTournament {
      participants {
        demographics {
          nationalities
        }
      }
    }
  }
}`;

export const TournamentNationalitiesCTPRange = `query TournamentCTPRangeLeaderboard(
  $tournamentId: ID!
) {
  node(id: $tournamentId) {
    ... on ClosestToPinTournament {
      participants {
        demographics {
          nationalities
        }
      }
    }
  }
}`;

export const TournamentOverviewCTPList = `query getTournamentOverviewCTPList($facilityId: ID!, $take: Int, $skip: Int, $list: TournamentListKinds, $isRange: Boolean) {
  node(id: $facilityId) {
    ... on Facility {
      tournaments {
        list(
          take: $take
          skip: $skip
          list: $list
          isRange: $isRange
        ) {
          totalCount
          items {
            ...TournamentOverviewCTPItem
          }
        }
      }
    }
  }
}
    
fragment TournamentOverviewCTPItem on Tournament {
  ...CourseTournamentCTPOverview
}
fragment CourseTournamentCTPOverview on ClosestToPinTournament {
  isRange
  startDate
  endDate
  id
  logo
  name
  sponsors {
    logoUri
    name
  }
  participants {
    allInvitationsCount
    declinedCount
    withdrawnCount
  }
  keyValues {
    key
    value
  }
  versionInfo {
    state
  }
  signUpStartTime
  signUpEndTime
  locationsConfiguration {
    paymentUrl
    remainingSpots
    fee
    displayFee
  } 
}`;

export const TournamentOverviewCTP = `query getTournamentCTP($tournamentId: ID!) {
  node(id: $tournamentId) {
    ...on ClosestToPinTournament {
      isRange
      unit
      settings {
        gameType
        allowPlayAhead
        allowMulligans
        attempts
        hcpKind
        gameFormat
        ignoreBottomRounds
      }
      sponsors {
        logoUri
        name
      }
      teamSettings {
        size
      }
      logo
      name
      femaleTee
      maleTee
      course {
        displayName
        description
        image {
          url
        }
        numbersOfHoles
        tees {
          name
          courseDistance
          par
        }
        tee {
          par
        }
              allTeeHoles: holes(holeTypes: PAR3_HOLES) {
      holeNumber
      images {
        url
      }
    }
    maleTeeHoles: holes(holeTypes: PAR3_HOLES, gender: MALE) {
      holeNumber
      tees {
        groupId
        distance
      }
    }
    femaleTeeHoles: holes(holeTypes: PAR3_HOLES, gender: FEMALE) {
      holeNumber
      tees {
        groupId
        distance
      }
    }
      }
      startDate
      endDate
      id
      logo
      name
      sponsors {
        logoUri
        name
      }
      holes {
        holeNumber
        pinId
      }
      gameSettings {
        fairwayFirmness
        greenFirmness
        greenStimp
        puttingMode
        windSpeed
        pinDifficulty
      }
      participants {
        allInvitationsCount
        declinedCount
        withdrawnCount
      }
      keyValues {
        key
        value
      }
      versionInfo {
        state
      }
      signUpStartTime
      signUpEndTime
      locationsConfiguration {
        paymentUrl
        remainingSpots
        fee
        displayFee
      } 
    }
  }
}`;

// Round (stroke play) leaderboard only; take 1 = the winner once the round is over.
export const TournamentWinner = `query getTournamentWinner($tournamentId: ID!) {
  node(id: $tournamentId) {
    ... on CourseTournament {
      leaderboard {
        records(skip: 0, take: 1) {
          items {
            playername
          }
        }
      }
    }
  }
}`;

export const TournamentBase =`query getTournament($tournamentId: ID!) {
  base: node(id: $tournamentId) {
    ... on Tournament {
      id
      isRange
    }
  }
  coursePlayTournament: node(id: $tournamentId) {
    ... on CourseTournament {
      rounds {
        id
      }
    }
  }
}`;
